import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSettingsAction } from '../../actions/settings.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateSocialYoutube } from '../../slices/settings.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const SocialYoutubePage = () => {
  const dispatch = useAppDispatch();

  const { social_youtube } = useAppSelector((store) => store.settings.list);

  const handleChange = (v: string) => {
    dispatch(updateSocialYoutube(v));
  };

  const handleSave = async () => {
    await dispatch(updateSettingsAction({ key: 'social_youtube', value: social_youtube }));
  };

  return (
    <ContainerTemplate>
      <Card title="Youtube" className={'border-2 border-yellow'}>
        <div>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={social_youtube ?? ''}
            onChange={({ target }) => handleChange(target.value)}
          />
        </div>
        <Button label="Сохранить" icon="pi pi-check" className={'mt-2'} onClick={handleSave} />
      </Card>
    </ContainerTemplate>
  );
};
